"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _menu = require("@alicd/next/lib/menu");

var _menu2 = _interopRequireDefault(_menu);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _balloon = require("@alicd/next/lib/balloon");

var _balloon2 = _interopRequireDefault(_balloon);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get3 = require("babel-runtime/helpers/get");

var _get4 = _interopRequireDefault(_get3);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SelectOnChangeFix2 = require("./SelectOnChangeFix");

var _SelectOnChangeFix3 = _interopRequireDefault(_SelectOnChangeFix2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectAllMonkey = function (_SelectOnChangeFix) {
    (0, _inherits3.default)(SelectAllMonkey, _SelectOnChangeFix);

    function SelectAllMonkey() {
        (0, _classCallCheck3.default)(this, SelectAllMonkey);
        return (0, _possibleConstructorReturn3.default)(this, (SelectAllMonkey.__proto__ || (0, _getPrototypeOf2.default)(SelectAllMonkey)).apply(this, arguments));
    }

    (0, _createClass3.default)(SelectAllMonkey, [{
        key: "getSelectedCount",
        value: function getSelectedCount() {
            var value = this.state.value;
            var n = value && value.length || 0;
            return n;
        }
    }, {
        key: "renderLabel",
        value: function renderLabel(label, value) {
            var _get2;

            for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                args[_key - 2] = arguments[_key];
            }

            var ret = (_get2 = (0, _get4.default)(SelectAllMonkey.prototype.__proto__ || (0, _getPrototypeOf2.default)(SelectAllMonkey.prototype), "renderLabel", this)).call.apply(_get2, [this, label, value].concat(args));
            if (this.props.multiple && this.props.compact) {
                var count =
                // container={this.refs.target}
                _react2.default.createElement(_balloon2.default.Tooltip, {
                    key: "count",
                    trigger: _react2.default.createElement(
                        "div",
                        { className: "cn-select-multi-count" },
                        this.props.statText(this.getSelectedCount(), this.getDataSource(this.props).length)
                    ),
                    text: Array.prototype.concat.apply([], label.map(function (l, i) {
                        return [l, i < label.length - 1 ? ", " : ""];
                    }))
                });
                return [ret, count];
            }
            return ret;
        }
    }, {
        key: "renderMenuContent",
        value: function renderMenuContent(dataSource) {
            if (!(this.props.multiple && this.props.hasSelectAll)) {
                return (0, _get4.default)(SelectAllMonkey.prototype.__proto__ || (0, _getPrototypeOf2.default)(SelectAllMonkey.prototype), "renderMenuContent", this).call(this, dataSource);
            } else {
                var ret = (0, _get4.default)(SelectAllMonkey.prototype.__proto__ || (0, _getPrototypeOf2.default)(SelectAllMonkey.prototype), "renderMenuContent", this).call(this, dataSource);

                var selectedAll = this.selectedAll(this.state.value);
                var optionSelectAll = this.renderMenuItem({
                    label: selectedAll ? this.props.cancelSelectAllText : this.props.selectAllText,
                    __key: this.props.selectAllValue
                }, dataSource.length);
                return [optionSelectAll].concat((0, _toConsumableArray3.default)(ret));
            }
        }
    }, {
        key: "renderMenuItem",
        value: function renderMenuItem(option, i) {
            var label = option.label,
                children = option.children,
                __key = option.__key,
                index = option.index,
                others = (0, _objectWithoutProperties3.default)(option, ["label", "children", "__key", "index"]);

            if (children) {
                return _react2.default.createElement(
                    _menu2.default.Group,
                    (0, _extends3.default)({}, others, { label: label, key: i }),
                    this.renderMenuContent(children)
                );
            } else {
                var MenuItem = this.props.multiple && this.props.compact ? _menu2.default.CheckboxItem : _menu2.default.Item;
                if (__key == this.props.selectAllValue && this.props.multiple && this.props.compact && this.selectedAll(this.state.value)) {
                    others.checked = true;
                }
                return _react2.default.createElement(
                    MenuItem,
                    (0, _extends3.default)({}, others, { key: __key }),
                    label
                );
            }
        }
    }, {
        key: "selectedAll",
        value: function selectedAll(value) {
            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;

            var dataSource = this.getFilteredDataSource(props);
            if (!Array.isArray(value) || !value.length) {
                return !this.getDataSource(props).length;
            }
            var valuesSet = new _set2.default();
            value.forEach(function (v) {
                return valuesSet.add(v);
            });
            return dataSource.every(function (v) {
                return valuesSet.has(v.__key);
            });
        }
    }, {
        key: "getAllValue",
        value: function getAllValue() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            var dataSource = this.getFilteredDataSource(props);
            return dataSource.map(function (v) {
                return v.__key;
            });
        }
    }, {
        key: "onSelect",
        value: function onSelect(value, context) {
            if (!(this.props.multiple && this.props.hasSelectAll)) {
                (0, _get4.default)(SelectAllMonkey.prototype.__proto__ || (0, _getPrototypeOf2.default)(SelectAllMonkey.prototype), "onSelect", this).call(this, value, context);
            } else {
                if (value.indexOf(this.props.selectAllValue) != -1) {
                    var selectedAll = this.selectedAll(value);
                    this.onSelect(selectedAll ? [] : this.getAllValue());
                } else {
                    (0, _get4.default)(SelectAllMonkey.prototype.__proto__ || (0, _getPrototypeOf2.default)(SelectAllMonkey.prototype), "onSelect", this).call(this, value, context);
                }
            }
        }
    }]);
    return SelectAllMonkey;
}(_SelectOnChangeFix3.default);

SelectAllMonkey.propTypes = (0, _assign2.default)({
    statText: _propTypes2.default.func
}, _SelectOnChangeFix3.default.propTypes);
SelectAllMonkey.defaultProps = (0, _assign2.default)({
    cancelSelectAllText: null,
    selectAllText: null,
    statText: null,
    selectAllValue: "select-all-custom-key",
    compact: false
}, _SelectOnChangeFix3.default.defaultProps);
exports.default = SelectAllMonkey;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-select-field@0.0.22@@alicd/crui-select-field/lib/SelectAllMonkey.js
// module id = 665
// module chunks = 0